module.exports = __webpack_public_path__ + "img/BitByByte-Logo.1c4486b5.png";